import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { useTheme } from 'styled-components';
import Tooltip from '../Tooltip';
import { Root, Message, Action, Icon, Copy } from './SnackbarContent.styles';

var copyIcon = _jsx(Copy, {});

var SnackbarContent = React.forwardRef(function (props, ref) {
  var action = props.action,
      icon = props.icon,
      message = props.message,
      _a = props.role,
      role = _a === void 0 ? 'alert' : _a,
      className = props.className,
      withCopy = props.withCopy,
      other = __rest(props, ["action", "icon", "message", "role", "className", "withCopy"]);

  var _b = useState(false),
      copied = _b[0],
      setCopied = _b[1];

  var theme = useTheme();
  var handleClick = useCallback(function (event) {
    var textContent = event.currentTarget.textContent;
    if (!withCopy || !textContent) return;
    window.navigator.clipboard.writeText(textContent);
    setCopied(true);
  }, [withCopy]);
  var handleMouseLeave = useCallback(function () {
    setCopied(false);
  }, []);
  return _jsx(Tooltip, __assign({
    title: copied ? copyIcon : null,
    withCorner: false,
    placement: "left",
    TransitionProps: {
      onExited: handleMouseLeave
    },
    PaperProps: {
      style: {
        backgroundColor: theme.palette.fill.secondary.highest
      }
    }
  }, {
    children: _jsxs(Root, __assign({
      role: role,
      ref: ref,
      className: classnames(className, {
        hasAction: action != null
      })
    }, other, {
      children: [icon ? _jsx(Icon, {
        children: React.cloneElement(icon, {
          color: 'inherit'
        })
      }) : null, _jsx(Message, __assign({
        className: classnames({
          withCopy: withCopy
        }),
        onClick: handleClick
      }, {
        children: message
      })), action ? _jsx(Action, {
        children: action
      }) : null]
    }))
  }));
});
export default SnackbarContent;